<template>
  <span class="st-badge" :class="`st-badge--${tone}`">
    <i v-if="icon" class="pi" :class="icon"></i>
    {{ text }}
  </span>
</template>

<script setup>
defineProps({
  text: { type: String, required: true },
  tone: { type: String, default: 'gray' }, // green | amber | red | gray | dark
  icon: { type: String, default: '' },
});
</script>

<style scoped>
.st-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.28rem 0.7rem;
  border-radius: 99px;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}
.st-badge .pi { font-size: 0.75rem; }
.st-badge--green { background: rgba(34,197,94,.12); color: #16a34a; }
.st-badge--amber { background: rgba(245,158,11,.14); color: #b45309; }
.st-badge--red   { background: rgba(239,68,68,.12); color: #dc2626; }
.st-badge--gray  { background: rgba(100,116,139,.12); color: #475569; }
.st-badge--dark  { background: rgba(15,23,42,.1); color: #1e293b; }
</style>
